import { useEffect, useRef, useState } from "react";

import { tr } from "../lib/i18n";
/** Touch + mouse signature canvas. onChange receives a PNG data URI (or null when cleared). */
export default function SignaturePad({ label, onChange, testid }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#111";
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const down = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture?.(e.pointerId);
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = ref.current.getContext("2d");
    ctx.lineTo(...pos(e));
    ctx.stroke();
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setEmpty(false);
    onChange(ref.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = ref.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setEmpty(true);
    onChange(null);
  };

  return (
    <div data-testid={testid}>
      <div className="flex items-center justify-between mb-1">
        <span className="kpi-label" style={{ letterSpacing: 0 }}>{label}</span>
        <button type="button" className="btn-ghost text-xs" onClick={clear} data-testid={`${testid}-clear`}>{tr("x.clear")}</button>
      </div>
      <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
        data-testid={`${testid}-canvas`}
        style={{ width: "100%", height: 150, background: "#fff", border: "1px dashed var(--divider)", touchAction: "none", display: "block", cursor: "crosshair" }} />
      <div className="text-[11px] mt-1" style={{ color: "var(--text-muted)" }}>{empty ? tr("x.sign_with_finger_or_mouse") : tr("x.signed")}</div>
    </div>
  );
}
